import { useEffect, useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";
import { periodParams } from "@/lib/reportsApi";
import { REPORTS } from "@/constants/testIds";
import PeriodSelector from "@/components/reports/PeriodSelector";
import OccupancyBars from "@/components/reports/OccupancyBars";
import NoShowCard from "@/components/reports/NoShowCard";
import { MostSoldTable } from "@/components/reports/ServicesRankingTables";
import FollowUpKpiCard from "@/components/followups/FollowUpKpiCard";

/** Dashboard reducido del Profesional: solo su propia actividad (ocupación,
 * sus servicios realizados y su tasa de no-show), sin cifras financieras
 * globales de la clínica. */
export default function ProfessionalDashboard() {
  const { user } = useAuth();
  const [period, setPeriod] = useState({ period: "month", start: "", end: "" });
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    if (period.period === "custom" && (!period.start || !period.end)) return;
    setLoading(true);
    api.get("/reports/professional-summary", { params: periodParams(period) })
      .then(({ data }) => setData(data))
      .catch((err) => toast({ title: "No se pudo cargar tu actividad", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" }))
      .finally(() => setLoading(false));
  }, [period]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="space-y-8" data-testid={REPORTS.professionalDashboard}>
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-serif text-4xl sm:text-5xl tracking-tight text-foreground">
            Hola, {user?.name?.split(" ")[0]}
          </h1>
          <p className="text-base text-muted-foreground mt-2">Este es el resumen de tu actividad.</p>
        </div>
        <PeriodSelector value={period} onChange={setPeriod} />
      </div>

      <FollowUpKpiCard />

      {loading || !data ? (
        <p className="text-center text-muted-foreground py-12">Cargando tu actividad...</p>
      ) : (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="bg-white border border-border rounded-xl p-5" data-testid={REPORTS.professionalOccupancyCard}>
            <h3 className="text-sm font-medium text-foreground mb-4">Mi ocupación</h3>
            <OccupancyBars data={[data.occupancy]} />
          </div>
          <NoShowCard noShow={data.no_show} testId={REPORTS.professionalNoShowCard} />
          <div className="lg:col-span-2">
            <MostSoldTable data={data.top_services} testId={REPORTS.professionalServicesTable} />
          </div>
        </div>
      )}
    </div>
  );
}
